import { sendRequest } from "./api";

interface IFolder {

}

const route = 'folders';

export const getFolders = () => {
    return sendRequest(route, 'GET', undefined, '');
}

export const postFolder = (item: IFolder) => {
    return sendRequest(route, 'POST', item, '');
}

export const getFolder = (itemId: string) => {
    return sendRequest(route + '/', 'GET', undefined, itemId);
}

export const putFolder = (item: IFolder, itemId: string) => {
    return sendRequest(route + '/', 'PUT', item, itemId);
}

export const deleteFolder = (itemId: string) => {
    return sendRequest(route + '/', 'DELETE', undefined, itemId);
}
